import script from "./win_ratepage_page.vue?vue&type=script&setup=true&lang=js"
export * from "./win_ratepage_page.vue?vue&type=script&setup=true&lang=js"

import "./win_ratepage_page.vue?vue&type=style&index=0&id=7500f2bd&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7500f2bd"]])

export default __exports__